export function wrapWithPrefixZero(value: number): string {
  return value < 10 ? `0${value}` : `${value}`
}

export function formatFromUnixMS(unixMS: number): string {
  // dd.mm.yyyy - hh:mm:ss
  const date = new Date(unixMS)
  const day = wrapWithPrefixZero(date.getDate())
  const month = wrapWithPrefixZero(date.getMonth() + 1)
  const year = date.getFullYear()
  const hours = wrapWithPrefixZero(date.getHours())
  const minutes = wrapWithPrefixZero(date.getMinutes())
  const seconds = wrapWithPrefixZero(date.getSeconds())
  return `${day}.${month}.${year} - ${hours}:${minutes}:${seconds}`
}
